<template>
  <!--begin::Wrapper container-->
  <div class="app-container container-xxl">
    <!--begin::Main-->
    <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
      <!--begin::Footer-->
      <div id="kt_app_footer" class="app-footer d-flex flex-column flex-md-row align-items-center flex-center flex-md-stack py-2 py-lg-4">
        <!--begin::Copyright-->
        <div class="text-gray-900 order-2 order-md-1">
          <span class="text-muted fw-semibold me-1">2024&copy;</span>
          <a href="https://keenthemes.com" target="_blank" class="text-gray-800 text-hover-primary">Xpertbooking</a>
        </div>
        <!--end::Copyright-->
      </div>
      <!--end::Footer-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterComponent',
  props: {
    
  }
};
</script>